module.exports = __webpack_public_path__ + "static/media/audio.92ed57e2.mp3";